import BaseScenarioPart from "../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { getNextPartId } from "../../../../misc/tools";
import { BaseGeneralConfig, GameBaseScenario, GeneralPartConfig } from "../../../GameBaseScenario";
import TransfusionComponentsStep1Part1 from "./transfusion-components-step1-parts/transfusion-components-step1-part1";

export default class TransfusionComponentsStep1Component {
	private _parts: BaseScenarioPart<GameBaseScenario>[] = [];
	private _partId1 = getNextPartId();
	public get parts() {
		return this._parts;
	}
	constructor(public config: TransfusionComponentsStep1ComponentMainConfig) {
		let context = this;
		context._parts.push(new TransfusionComponentsStep1Part1(context.config.scenario, () => {
			config.onDone();
		}, context._partId1, config));
	}

	public start() {
		this.goToPart1();
	}

	goToPart1() {
		this.config.scenario.loadPart(this._partId1);
	}
}

export interface TransfusionComponentsStep1ComponentMainConfig extends BaseGeneralConfig {
	scenario: GameBaseScenario;
	part1Config?: TransfusionComponentsStep1ComponentPart1Config;
	onDone: () => void;
}

export interface TransfusionComponentsStep1ComponentPart1Config extends GeneralPartConfig {
	chapter: () => string;
}